import React, { useCallback, useState } from 'react'
import CorendonWidget from '../components/CorendonWidget'
import InstallPwaSheet from '../components/InstallPwaSheet'
import { detectInitialLocale, persistLocale, t } from '../i18n'

const HELP_ITEMS = [
  { num: '01', key: 'helpItem1' },
  { num: '02', key: 'helpItem2' },
  { num: '03', key: 'helpItem3' },
]

export default function HomePage({ user }) {
  const [locale, setLocale] = useState(() => detectInitialLocale())

  const onLocaleChange = useCallback((next) => {
    setLocale(next)
    persistLocale(next)
    if (typeof document !== 'undefined') {
      document.documentElement.lang = next
    }
  }, [])

  return (
    <div className="flex min-h-full flex-col bg-white text-gray-900">
      <main className="flex flex-1 flex-col items-stretch px-6 py-12 sm:py-20">
        <div className="mx-auto w-full max-w-xl">
          {/* Eyebrow */}
          <div className="mb-4 flex items-center gap-2 text-[11px] font-medium uppercase tracking-micro text-corendon-red">
            <span className="h-px w-6 bg-corendon-red" />
            <span>{t(locale, 'brandTagline')}</span>
          </div>

          {/* Headline + lead */}
          <h1 className="text-[28px] font-semibold leading-tight tracking-tight text-gray-900 sm:text-[34px]">
            {t(locale, 'heroTitle')}
          </h1>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-gray-600">
            {t(locale, 'heroSubtitle')}
          </p>

          {/* Action zone */}
          <div className="mt-8">
            <CorendonWidget
              locale={locale}
              onLocaleChange={onLocaleChange}
              userEmail={user?.email}
            />
          </div>

          {/* Capability list — numbered, editorial */}
          <div className="mt-14">
            <div className="mb-3 text-[11px] font-medium uppercase tracking-micro text-gray-500">
              {t(locale, 'helpListTitle')}
            </div>
            <ul className="divide-y divide-gray-100 border-y border-gray-100">
              {HELP_ITEMS.map((item) => (
                <li
                  key={item.num}
                  className="flex items-center gap-5 py-3.5 text-[14px] text-gray-800"
                >
                  <span className="w-6 shrink-0 font-mono text-[11px] tracking-tight text-gray-400">
                    {item.num}
                  </span>
                  <span className="flex-1">{t(locale, item.key)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </main>

      <footer className="border-t border-gray-100 px-6 py-5">
        <div className="mx-auto flex max-w-xl items-center justify-between gap-3 text-[11px] text-gray-400">
          <span>{t(locale, 'footerDemo')}</span>
          <span className="hidden font-mono uppercase tracking-[0.14em] sm:inline">
            v1 · corendon.imora.nl
          </span>
        </div>
      </footer>

      <InstallPwaSheet locale={locale} />
    </div>
  )
}
